import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const EmployeeAccordion = ({
  children,
  defaultExpanded = true,
  label = 'Employee Info',
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`w-full ${className}`}>
      {/* Accordion Header */}
      <div
        className="flex items-center cursor-pointer mt-4"
        onClick={() => setIsExpanded(!isExpanded)}
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setIsExpanded(!isExpanded);
          }
        }}
      >
        <div className="items-center flex-grow border-b-2 border-black ml-2">
          <span className="text-black font-semibold ml-2">{label}</span>
          {isExpanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </div>
      </div>
      {/* Accordion Content */}
      {isExpanded && <div className="mt-4">{children}</div>}
    </div>
  );
};

EmployeeAccordion.propTypes = {
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};

export default EmployeeAccordion;
